export function isVotePendingForViewer(voteState, viewerColor) {
    if (voteState == undefined) return false;
    if (!voteState.participatingPlayers.includes(viewerColor)) return false;
    const allVotes = [
        ...voteState.acceptedVotes,
        ...voteState.declinedVotes
    ];
    return !allVotes.includes(viewerColor);
}
